import React from 'react';
import { Button, Dropdown } from '@insurancemenu/imenu-components-lib';
import {
  ChevronDown,
  CloudUpload,
  Tools,
  InsertChart,
  Mail,
  Reload,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { bpHistory } from 'global/bpHistory';
import { createStyles } from './styles';

const MoreDropdown: React.FC = observer(() => {
  const classes = createStyles();

  const {
    triggerRenewalsStore: { openWarningModal, generateExhibits },
  } = useRootStore();

  const moreActionsDropdownOptions: DropdownOptionType[] = [
    {
      value: 'triggerAll',
      onOptionClick: (): void => {
        openWarningModal('TRIGGER_ALL');
      },
      icon: Mail,
      label: 'Trigger All',
    },
    {
      value: 'sendStatistic',
      onOptionClick: (): void => {
        openWarningModal('SEND_STATISTIC');
      },
      icon: InsertChart,
      label: 'Send Statistics',
    },
    {
      value: 'uploadExhibits',
      onOptionClick: (): void => {
        bpHistory.push('/upload-exhibits');
      },
      icon: CloudUpload,
      label: 'Upload Exhibits',
    },
    {
      value: 'generateExhibits',
      onOptionClick: generateExhibits,
      icon: Tools,
      label: 'Generate Exhibits',
    },
    {
      value: 'moveToRenewal',
      onOptionClick: (): void => {
        openWarningModal('MOVE_ALL_TO_RENEWAL');
      },
      icon: Reload,
      label: 'Move All to Renewal',
    },
  ];

  return (
    <Dropdown
      name="More"
      options={moreActionsDropdownOptions}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
      optionsWidth="25rem"
      closedElement={
        <Button
          className={clsx(classes.dropdownOpenedBtn, classes.dropdownButton)}
          color="primary"
          size="large"
          rightIconProp={<ChevronDown />}
        >
          MORE ACTIONS
        </Button>
      }
      openedElement={
        <Button color="primary" size="large" className={classes.dropdownButton} rightIconProp={<ChevronDown />}>
          MORE ACTIONS
        </Button>
      }
    />
  );
});

export default MoreDropdown;
